
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/media/album/[slug]",
      function () {
        return require("private-next-pages/media/album/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/media/album/[slug]"])
      });
    }
  